'use client';
import { forwardRef } from 'react';
import useSxProps from '../hooks/use-sx-props.mjs';
import { jsx } from '@emotion/react/jsx-runtime';

// src/box/index.tsx
var Box = forwardRef(
  ({ as, sx, ...props }, ref) => {
    const Component = as || "div";
    const mergeSxProps = useSxProps();
    return /* @__PURE__ */ jsx(Component, { ref, css: mergeSxProps(sx), ...props });
  }
);
Box.displayName = "Box";
var box_default = Box;

export { box_default as default };
